import React from 'react';
import Item from './Item';
import data from './Sidebar.json';

const Sidebar = () => {
    return (
        <ul className="sidebar__menu">
            {data.map((item, index) => (
                <Item key={index} {...item} isNextDivider={data[index + 1] && data[index + 1].type === 'divider'} />
            ))}
        </ul>
    );
};

export default Sidebar;
